$(document).ready(function(){
    $("input,select").on("focus",function(){$(this).parents(".form-group,.input-group").children("label").toggleClass("active-input-label")});
    $("input,select").on("blur",function(){$(this).parents(".form-group,.input-group").children("label").toggleClass("active-input-label")});
});